import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import workingTruckMarker from 'components/shipment/maps/markers/working-truck.png';
import activeTruckMarker from 'components/shipment/maps/markers/truck.png';
import DriverJobsPopover from 'components/modules/shipments/tracking/DriverJobsPopover';

class DriverMarker extends Component {
  static propTypes = {
    isActive: PropTypes.bool.isRequired,
    listOpen: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired,
    position: PropTypes.object.isRequired,
    map: PropTypes.object.isRequired,
    driver: PropTypes.shape({
      fullName: PropTypes.string,
      phone: PropTypes.string,
    }).isRequired,
    phone: PropTypes.string,
    jobs: PropTypes.arrayOf(PropTypes.object).isRequired,
    onMarkerClick: PropTypes.func.isRequired,
    onCloseInfoWindow: PropTypes.func.isRequired,
    hasActiveJobs: PropTypes.bool,
  };

  static defaultProps = {
    phone: null,
  };

  componentDidMount() {
    this.createMarker();

    this.createInfoWindow();
    this.updateInfoWindow(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.updateIcon(nextProps.hasActiveJobs);
    this.updatePosition(nextProps.position);
    this.updateInfoWindow(nextProps);

    const { listOpen } = this.props;

    if (listOpen && !nextProps.listOpen) {
      this.closeInfoWindow();
    }
  }

  componentWillUnmount() {
    if (this.markerListener) {
      google.maps.event.removeListener(this.markerListener);
      this.marker.setMap(null);
      this.marker = null;
    }

    if (this.infoWindowListener) {
      google.maps.event.removeListener(this.infoWindowListener);
      this.infoWindow.setMap(null);
      this.infoWindow = null;
    }
  }

  handleMarkerClick = () => {
    this.infoWindow.open(this.props.map, this.marker);
    this.props.onMarkerClick(this.props.id);
    this.props.setCurrentMarker(this.props.id, this.infoWindow);
  };

  handleInfoWindowCloseClick = () => {
    this.props.onCloseInfoWindow(this.props.id);
  };

  updatePosition(position) {
    this.marker.setPosition(position);
  }

  updateIcon(hasActiveJobs) {
    const newIcon = hasActiveJobs ? activeTruckMarker : workingTruckMarker;
    this.marker.setIcon(newIcon);
  }

  updateInfoWindow(nextProps) {
    const driverJobs = (
      <DriverJobsPopover
        hasActiveJobs={nextProps.hasActiveJobs}
        jobs={nextProps.jobs}
        driver={nextProps.driver}
        phone={nextProps.phone}
        onOpenShipment={nextProps.onOpenShipment}
      />
    );
    ReactDOM.render(driverJobs, this.rootElement);
  }

  createMarker() {
    this.marker = new google.maps.Marker({
      map: this.props.map,
      icon: workingTruckMarker,
      position: this.props.position,
    });
  }

  createInfoWindow() {
    this.infoWindow = new google.maps.InfoWindow({
      disableAutoPan: true,
    });
    this.rootElement = document.createElement('div');
    this.infoWindow.setContent(this.rootElement);

    this.markerListener = this.marker.addListener(
      'click',
      this.handleMarkerClick,
    );

    this.infoWindowListener = this.infoWindow.addListener(
      'closeclick',
      this.handleInfoWindowCloseClick,
    );
  }

  closeInfoWindow() {
    if (this.infoWindow) {
      this.infoWindow.close();
    }
  }
  render() {
    return null;
  }
}

export default DriverMarker;
